module.exports = __webpack_public_path__ + "img/marker-restaurant.36db1997.svg";